import { useEffect, useState } from 'react';
import type { BroadcastAudienceKind, BroadcastPurpose } from '@/api/broadcasts/broadcastsApi.types';
import { usePreviewBroadcastAudienceMutation } from '@/hooks/useBroadcasts';

function splitSelectionKey(selectionKey: string): string[] {
  return selectionKey.length === 0 ? [] : selectionKey.split(',');
}

export function useMarketingConsentedCount(
  purpose: BroadcastPurpose,
  audienceKind: BroadcastAudienceKind,
  selectedClientIds: string[]
): number | null {
  const previewMutation = usePreviewBroadcastAudienceMutation();
  const [consentedCount, setConsentedCount] = useState<number | null>(null);
  const { mutate: requestPreview } = previewMutation;
  const selectionKey = selectedClientIds.join(',');

  useEffect(
    function refreshConsentedCount() {
      if (purpose !== 'marketing') {
        setConsentedCount(null);
        return;
      }
      requestPreview(
        {
          audienceKind,
          purpose,
          selectedClientIds:
            audienceKind === 'selected_clients' ? splitSelectionKey(selectionKey) : null,
        },
        {
          onSuccess: function storeCount(preview) {
            setConsentedCount(preview.consentedRecipients);
          },
        }
      );
    },
    [purpose, audienceKind, selectionKey, requestPreview]
  );

  return consentedCount;
}
